module.exports = __webpack_public_path__ + "img/lianminglogo.0b6e5ccd.png";